import { render } from "./ClozeAssignmentList.vue?vue&type=template&id=4bc4ea60&scoped=true"
import script from "./ClozeAssignmentList.vue?vue&type=script&lang=js"
export * from "./ClozeAssignmentList.vue?vue&type=script&lang=js"

import "./ClozeAssignmentList.vue?vue&type=style&index=0&id=4bc4ea60&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc4ea60"]])

export default __exports__